import { FC } from "react";
import { StyledFooter } from "./style";

const CardFooter: FC = ({ children }) => {
  return <StyledFooter>{children}</StyledFooter>;
};

export default CardFooter;
